import $ from 'jquery'
import * as logger from '../../../abt-utils/logger'
import * as shared from '../shared'

export function customCriteria (test) {
  return shared.customCriteria(test)
}

export function a (test) {
  shared.markItems(shared.plpView(), 'a')
  _toggleViewEvents('a')
  return test
}

export function b (test) {
  shared.markItems(shared.plpView(), 'b')
  _toggleViewEvents('b')

  return System.import('../less/styles.less')
    .catch(logger.error)
}

function _toggleViewEvents (recipe) {
  $('button.display-list-view').click(function () {
    if (shared.plpView() === 'list') return
    shared.markItems('list', recipe)
  })

  $('button.display-grid-view').click(function () {
    if (shared.plpView() === 'grid') return
    shared.markItems('grid', recipe)
  })
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-tests/abt524/large/index.js
 ** module id = 54
 ** module chunks = 2
 **/